// extracted by mini-css-extract-plugin
export var actions = "_qb-5";
export var assistantBubble = "_qb-3";
export var assistantRow = "_qb-6";
export var bubble = "_qb-0";
export var humanAvatar = "_qb-4";
export var inlineToolCard = "_qb-1";
export var userBubble = "_qb-2";